<template>
  <div>
    <Head title="Product Families" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/settings/products/families">Familias</Link>
        <span class="text-indigo-400 font-medium">/ Editar</span>
      </h1>      
    </div>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">                    
          <text-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-full" label="Descripción" />
          
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-sky" type="submit">Actualizar Familia</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Multiselect from '@vueform/multiselect'
import TextInputUpper from '@/Shared/TextInputUpper'
import SelectInput from '@/Shared/SelectInput'

export default {
  components: {
    Head,    
    Link,
    SelectInput,
    TextInput,    
    LoadingButton,
    Multiselect,    
    TrashedMessage,
    TextInputUpper
  },
  layout: Layout,
  props: {
    family: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({        
        description: this.family.description,        
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/settings/products/families/${this.family.id}`)
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>